var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
import { isRecordEmpty, removeDuplicates } from 'hx-util';
export var useParticipant = function (_a) {
    var room = _a.room, onNewParticipantConnected = _a.onNewParticipantConnected, onParticipantDisconnected = _a.onParticipantDisconnected;
    var _b = useState([]), participants = _b[0], setParticipants = _b[1];
    var localParticipant = room && room.localParticipant;
    useEffect(function () {
        if (isRecordEmpty(room))
            return;
        var handleAlreadyConnected = function (participant) {
            return setParticipants(function (p) { return removeDuplicates(__spreadArray(__spreadArray([], p, true), [participant], false)); });
        };
        var handleNewConnected = function (participant) {
            setParticipants(function (p) { return removeDuplicates(__spreadArray(__spreadArray([], p, true), [participant], false)); });
            onNewParticipantConnected && onNewParticipantConnected(participant);
        };
        var handleParticipantDisconnected = function (participant) {
            setParticipants(function (current) { return current.filter(function (p) { return p !== participant; }); });
            onParticipantDisconnected && onParticipantDisconnected(participant);
        };
        room.participants.forEach(handleAlreadyConnected);
        room.on('participantConnected', handleNewConnected);
        room.on('participantDisconnected', handleParticipantDisconnected);
        return function () {
            room.off('participantConnected', handleNewConnected);
            room.off('participantDisconnected', handleParticipantDisconnected);
        };
    }, [onNewParticipantConnected, onParticipantDisconnected, room]);
    return { localParticipant: localParticipant, remoteParticipants: participants };
};
